<template>
	<div>
		<!--banner home start -->
		<section class="home_banner marginTop_fixed">
			<div class="container">
				<div class="row">
					<div class="col-md-6">
						<div class="homebanner">
							<h1>The world is open for your business</h1>
							<p class="laptopshow">
								The all-in-one platform that increases your Company's online
								success in a simple and complete way. No technical skills are
								required
							</p>

							<div class="home_newsletter">
								<form action="#">
									<label for="">
										<input
											type="email"
											name="email"
											placeholder="Enter your email address"
										/>
										<input type="submit" name="submit" value="Start trial" />
									</label>
								</form>
								<p class="laptopshow">Try SEO Suite 7 days for 7 Euros</p>
							</div>
							<p class="mobileshow schomepara">
								The all-in-one platform that increases your Company's online
								success in a simple and complete way. No technical skills are
								required
							</p>
						</div>
					</div>
					<div class="col-md-6 homefullmb">
						<div
							class="homebanner_img"
							:style="{
								'background-image':
									'url(' + require(`@/assets/images/bg-1.jpg`) + ')',
								'background-position': 'bottom center',
								'background-repeat': 'no-repeat',
								'background-size': 'cover',
							}"
						>
							<div class="playvideo">
								<a
									href="https://www.youtube.com/watch?v=s8SrerotCV8"
									data-fancybox
								>
									<img src="@/assets/images/play.svg" alt="" /> Play video
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
		<!--end-->

		<!--Logo Partner-->
		<section>
			<div class="container">
				<div class="row align-items-center">
					<div class="col-md-12">
						<ul class="partnerlogo">
							<li class="right-border">
								<img src="@/assets/images/logo/logo-1.svg" alt="" />
							</li>
							<li class="right-border">
								<img src="@/assets/images/logo/logo-2.svg" alt="" />
							</li>
							<li class="right-border">
								<img src="@/assets/images/logo/logo-3.svg" alt="" />
							</li>
							<li class="right-border">
								<img src="@/assets/images/logo/logo-4.svg" alt="" />
							</li>
							<li><img src="@/assets/images/logo/logo-5.svg" alt="" /></li>
							<li class="right-border">
								<img src="@/assets/images/logo/logo-6.svg" alt="" />
							</li>
							<li class="right-border">
								<img src="@/assets/images/logo/logo-7.svg" alt="" />
							</li>
							<li class="right-border">
								<img src="@/assets/images/logo/logo-8.svg" alt="" />
							</li>
							<li class="right-border">
								<img src="@/assets/images/logo/logo-9.svg" alt="" />
							</li>
							<li class="lastmb">
								<img src="@/assets/images/logo/logo-10.svg" alt="" />
							</li>
						</ul>
					</div>
				</div>
			</div>
		</section>
		<!--END-->

		<!--Start Services -->
		<section class="main_home_services">
			<div class="container">
				<div class="row">
					<div class="col-md-12">
						<h2>We automated the 6 pillars of web success</h2>
					</div>
				</div>
				<!--start row-->
				<div class="row">
					<!--col-start-->
					<div class="col-md-4">
						<div class="boxservice">
							<h3>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="40"
									height="40"
									viewBox="0 0 40 40"
								>
									<g id="icon1" transform="translate(-15 -15)">
										<g id="Group_1" data-name="Group 1">
											<rect
												id="Rectangle_1"
												data-name="Rectangle 1"
												width="40"
												height="40"
												rx="10"
												transform="translate(15 15)"
												fill="#347362"
											/>
										</g>
										<path
											id="Path_1"
											data-name="Path 1"
											d="M44.723,30.562l-.665-1.124a2.073,2.073,0,0,0-2.787-.733,2.081,2.081,0,0,1-1.543.211A2.029,2.029,0,0,1,38.485,28a1.868,1.868,0,0,1-.274-.952,1.962,1.962,0,0,0-.577-1.444,2.071,2.071,0,0,0-1.466-.6H34.829a2.061,2.061,0,0,0-1.442.584,1.955,1.955,0,0,0-.592,1.407,2.019,2.019,0,0,1-2.043,1.962,2,2,0,0,1-.978-.267,2.073,2.073,0,0,0-2.787.733l-.714,1.143a1.962,1.962,0,0,0,.743,2.714,1.965,1.965,0,0,1,0,3.448,1.953,1.953,0,0,0-.743,2.7l.675,1.133a2.035,2.035,0,0,0,1.229.95,2.091,2.091,0,0,0,1.558-.178,2.071,2.071,0,0,1,1.543-.2,2.017,2.017,0,0,1,1.234.925,1.868,1.868,0,0,1,.274.952A2.018,2.018,0,0,0,34.829,45h1.339a2.018,2.018,0,0,0,2.044-1.981,1.955,1.955,0,0,1,.6-1.41,2.061,2.061,0,0,1,1.448-.58,2.124,2.124,0,0,1,.978.267,2.073,2.073,0,0,0,2.787-.724l.7-1.143a1.936,1.936,0,0,0,.208-1.508,1.988,1.988,0,0,0-.951-1.207,1.989,1.989,0,0,1-.951-1.207A1.936,1.936,0,0,1,43.237,34a1.979,1.979,0,0,1,.743-.724,1.962,1.962,0,0,0,.743-2.7Z"
											fill="none"
											stroke="#f5f3ee"
											stroke-linecap="round"
											stroke-linejoin="round"
											stroke-width="1.5"
											fill-rule="evenodd"
										/>
										<path
											id="Path_2"
											data-name="Path 2"
											d="M35.5,37.742A2.744,2.744,0,1,0,32.688,35,2.78,2.78,0,0,0,35.5,37.742Z"
											fill="none"
											stroke="#f5f3ee"
											stroke-linecap="round"
											stroke-linejoin="round"
											stroke-width="1.5"
										/>
									</g>
								</svg>
								<span>Technical Analysis</span>
							</h3>
							<p>
								Do in-dept and easy technical analysis of your website, page by
								page.
							</p>

							<router-link
								class="textlink"
								:to="`/${$i18n.locale}/technical-analysis`"
								><span>Learn more</span>
								<svg
									width="11"
									height="9"
									viewBox="0 0 11 9"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M0 4.5H10M10 4.5L6.5 1M10 4.5L6.5 8"
										stroke="#EF8451"
										stroke-width="1.5"
										stroke-linejoin="round"
									/></svg
							></router-link>
						</div>
					</div>
					<!--end col-->
					<!--col-start-->
					<div class="col-md-4">
						<div class="boxservice">
							<h3>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="40"
									height="40"
									viewBox="0 0 40 40"
								>
									<g id="icon2" transform="translate(-15 -15)">
										<g id="Group_2" data-name="Group 2">
											<rect
												id="Rectangle_2"
												data-name="Rectangle 2"
												width="40"
												height="40"
												rx="10"
												transform="translate(15 15)"
												fill="#edcb50"
											/>
										</g>
										<path
											id="Path_3"
											data-name="Path 3"
											d="M31,29.5h8m-8,3h8m-8,3h4.5m5,2.5H38m-2.5,0H38m0,0v4.5M43,28V43a2,2,0,0,1-2,2H29a2,2,0,0,1-2-2V28a2,2,0,0,1,2-2H41A2,2,0,0,1,43,28Z"
											fill="none"
											stroke="#f5f3ee"
											stroke-linejoin="round"
											stroke-width="1.5"
										/>
									</g>
								</svg>
								<span>Content Analysis</span>
							</h3>
							<p>
								Make your content perfect for both people and search engines.
							</p>
							<router-link
								class="textlink"
								:to="`/${$i18n.locale}/content-analysis`"
								><span>Learn more</span>
								<svg
									width="11"
									height="9"
									viewBox="0 0 11 9"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M0 4.5H10M10 4.5L6.5 1M10 4.5L6.5 8"
										stroke="#EF8451"
										stroke-width="1.5"
										stroke-linejoin="round"
									/></svg
							></router-link>
						</div>
					</div>
					<!--end col-->
					<!--col-start-->
					<div class="col-md-4">
						<div class="boxservice">
							<h3>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									xmlns:xlink="http://www.w3.org/1999/xlink"
									width="40"
									height="40"
									viewBox="0 0 40 40"
								>
									<defs>
										<clipPath id="clip-path">
											<rect
												id="Rectangle_4"
												data-name="Rectangle 4"
												width="18"
												height="18"
												transform="translate(26 26)"
												fill="#fff"
											/>
										</clipPath>
									</defs>
									<g id="icon3" transform="translate(-15 -15)">
										<g id="Group_3" data-name="Group 3">
											<rect
												id="Rectangle_3"
												data-name="Rectangle 3"
												width="40"
												height="40"
												rx="10"
												transform="translate(15 15)"
												fill="#ef8451"
											/>
										</g>
										<g
											id="Group_4"
											data-name="Group 4"
											clip-path="url(#clip-path)"
										>
											<path
												id="Path_4"
												data-name="Path 4"
												d="M42.975,29.14h0a.907.907,0,0,1-.019,1.313l-.007.006-.007.007-2.456,2.456-3.411-3.436,2.459-2.46h0a.939.939,0,0,1,1.327,0ZM27.665,38.9l7.559-7.559,3.437,3.441-7.56,7.56-4.3.859Zm-.04.04h0l-.132-.132.132.132Z"
												fill="none"
												stroke="#f5f3ee"
												stroke-width="1.5"
											/>
											<path
												id="Path_5"
												data-name="Path 5"
												d="M34,43.5H44"
												fill="none"
												stroke="#f5f3ee"
												stroke-width="1.5"
											/>
										</g>
									</g>
								</svg>
								<span>Content Generator</span>
							</h3>
							<p>
								Advanced AI-powered tool to write blogs, social media, ADS,
								sales letters & more.
							</p>
							<router-link
								class="textlink"
								:to="`/${$i18n.locale}/content-generator`"
								><span>Learn more</span>
								<svg
									width="11"
									height="9"
									viewBox="0 0 11 9"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M0 4.5H10M10 4.5L6.5 1M10 4.5L6.5 8"
										stroke="#EF8451"
										stroke-width="1.5"
										stroke-linejoin="round"
									/></svg
							></router-link>
						</div>
					</div>
					<!--end col-->
					<!--col-start-->
					<div class="col-md-4">
						<div class="boxservice">
							<h3>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="40"
									height="40"
									viewBox="0 0 40 40"
								>
									<g id="icon4" transform="translate(-15 -15)">
										<g id="Group_5" data-name="Group 5">
											<rect
												id="Rectangle_5"
												data-name="Rectangle 5"
												width="40"
												height="40"
												rx="10"
												transform="translate(15 15)"
												fill="#4952a7"
											/>
										</g>
										<path
											id="Path_6"
											data-name="Path 6"
											d="M39.5,32.75l-4.276,2.138a.5.5,0,0,1-.447,0L30.5,32.75m9,0,3.606-1.8a.5.5,0,0,0,0-.894l-7.882-3.941a.5.5,0,0,0-.447,0l-7.882,3.941a.5.5,0,0,0,0,.894l3.606,1.8m9,0,3.606,1.8a.5.5,0,0,1,0,.894L39.5,37.25m-9-4.5-3.606,1.8a.5.5,0,0,0,0,.894l3.606,1.8m9,0-4.276,2.138a.5.5,0,0,1-.447,0L30.5,37.25m9,0,3.606,1.8a.5.5,0,0,1,0,.894l-7.882,3.941a.5.5,0,0,1-.447,0l-7.882-3.941a.5.5,0,0,1,0-.894l3.606-1.8"
											fill="none"
											stroke="#f5f3ee"
											stroke-width="1.5"
										/>
									</g>
								</svg>
								<span>Project Management</span>
							</h3>
							<p>The easiest way for teams to know who's doing what by when.</p>
							<router-link
								class="textlink"
								:to="`/${$i18n.locale}/project-management`"
								><span>Learn more</span>
								<svg
									width="11"
									height="9"
									viewBox="0 0 11 9"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M0 4.5H10M10 4.5L6.5 1M10 4.5L6.5 8"
										stroke="#EF8451"
										stroke-width="1.5"
										stroke-linejoin="round"
									/></svg
							></router-link>
						</div>
					</div>
					<!--end col-->
					<!--col-start-->
					<div class="col-md-4">
						<div class="boxservice">
							<h3>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="40"
									height="40"
									viewBox="0 0 40 40"
								>
									<g id="icon5" transform="translate(-15 -15)">
										<g id="Group_6" data-name="Group 6">
											<rect
												id="Rectangle_6"
												data-name="Rectangle 6"
												width="40"
												height="40"
												rx="10"
												transform="translate(15 15)"
												fill="#eb5858"
											/>
										</g>
										<circle
											id="Ellipse_1"
											data-name="Ellipse 1"
											cx="2.25"
											cy="2.25"
											r="2.25"
											transform="translate(26 37.25)"
											fill="none"
											stroke="#f5f3ee"
											stroke-width="1.5"
										/>
										<circle
											id="Ellipse_2"
											data-name="Ellipse 2"
											cx="2.25"
											cy="2.25"
											r="2.25"
											transform="translate(39.5 37.25)"
											fill="none"
											stroke="#f5f3ee"
											stroke-width="1.5"
										/>
										<circle
											id="Ellipse_3"
											data-name="Ellipse 3"
											cx="2.25"
											cy="2.25"
											r="2.25"
											transform="translate(32.75 30.5) rotate(-90)"
											fill="none"
											stroke="#f5f3ee"
											stroke-width="1.5"
										/>
										<path
											id="Path_7"
											data-name="Path 7"
											d="M31.625,42.875A6.294,6.294,0,0,0,35,44a6.294,6.294,0,0,0,3.375-1.125"
											fill="none"
											stroke="#f5f3ee"
											stroke-linejoin="round"
											stroke-width="1.5"
										/>
										<path
											id="Path_8"
											data-name="Path 8"
											d="M41.75,35.563a6.4,6.4,0,0,0-.733-2.592,7.9,7.9,0,0,0-2.079-2.47"
											fill="none"
											stroke="#f5f3ee"
											stroke-linejoin="round"
											stroke-width="1.5"
										/>
										<path
											id="Path_9"
											data-name="Path 9"
											d="M28.25,35.563a6.4,6.4,0,0,1,.733-2.592,7.9,7.9,0,0,1,2.08-2.47"
											fill="none"
											stroke="#f5f3ee"
											stroke-linejoin="round"
											stroke-width="1.5"
										/>
									</g></svg
								><span>Brand reputation</span>
							</h3>
							<p>
								Your brand's profitability and success hinge on having a great
								online reputation.
							</p>
							<router-link
								class="textlink"
								:to="`/${$i18n.locale}/brand-reputation`"
								><span>Learn more</span>
								<svg
									width="11"
									height="9"
									viewBox="0 0 11 9"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M0 4.5H10M10 4.5L6.5 1M10 4.5L6.5 8"
										stroke="#EF8451"
										stroke-width="1.5"
										stroke-linejoin="round"
									/></svg
							></router-link>
						</div>
					</div>
					<!--end col-->
					<!--col-start-->
					<div class="col-md-4">
						<div class="boxservice">
							<h3>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="40"
									height="40"
									viewBox="0 0 40 40"
								>
									<g id="icon6" transform="translate(-15 -15)">
										<g id="Group_7" data-name="Group 7">
											<rect
												id="Rectangle_7"
												data-name="Rectangle 7"
												width="40"
												height="40"
												rx="10"
												transform="translate(15 15)"
												fill="#a656e4"
											/>
										</g>
										<path
											id="Path_10"
											data-name="Path 10"
											d="M26,40V30a2,2,0,0,1,2-2H42a2,2,0,0,1,2,2V40a2,2,0,0,1-2,2H28A2,2,0,0,1,26,40Z"
											fill="none"
											stroke="#f5f3ee"
											stroke-linejoin="round"
											stroke-width="1.5"
										/>
										<path
											id="Path_11"
											data-name="Path 11"
											d="M26,32H44"
											fill="none"
											stroke="#f5f3ee"
											stroke-width="1.5"
										/>
										<path
											id="Path_12"
											data-name="Path 12"
											d="M29,35v5"
											fill="none"
											stroke="#f5f3ee"
											stroke-width="1.5"
										/>
										<path
											id="Path_13"
											data-name="Path 13"
											d="M42,36H32"
											fill="none"
											stroke="#f5f3ee"
											stroke-width="1.5"
										/>
										<path
											id="Path_14"
											data-name="Path 14"
											d="M42,39H32"
											fill="none"
											stroke="#f5f3ee"
											stroke-width="1.5"
										/>
									</g>
								</svg>
								<span>CRM</span>
							</h3>
							<p>
								Totally customizable CRM for every business, for every industry.
							</p>
							<router-link class="textlink" :to="`/${$i18n.locale}/crm`"
								><span>Learn more</span>
								<svg
									width="11"
									height="9"
									viewBox="0 0 11 9"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M0 4.5H10M10 4.5L6.5 1M10 4.5L6.5 8"
										stroke="#EF8451"
										stroke-width="1.5"
										stroke-linejoin="round"
									/></svg
							></router-link>
						</div>
					</div>
					<!--end col-->
				</div>
				<!--end-->
			</div>
		</section>
		<!--END-->

		<!--start text scroll-->
		<section class="text_scroll">
			<h3>See what you can easily do!</h3>
			<p>Let SEO Suite be your right arm</p>
			<ul class="text-horizontal-scroll">
				<carousel
					:autoplay="true"
					:nav="false"
					:responsive="{
						0: { items: 2, margin: 20 },
						450: { items: 3, margin: 20 },
						768: { items: 4, margin: 20 },
						1000: { items: 5, margin: 20 },
						1200: { items: 6, margin: 20 },
					}"
				>
					<li>Backlink</li>
					<li>Marketing Automation</li>
					<li>SEO Audit</li>
					<li>Keyword Research</li>
					<li>Content Marketing</li>
					<li>Competitor Analisys</li>
					<li>Email Marketing</li>
					<li>Technical Analysis</li>
					<li>Content Analysis</li>
					<li>Project Management</li>
					<li>CRM</li>
					<li>Brand Reputation</li>
					<li>Content Generator</li>
				</carousel>
			</ul>
		</section>
		<!--end -->

		<!--testimonials-->
		<section class="home_testimonial">
			<div class="container">
				<div class="row">
					<div class="col-md-12 text-center">
						<svg
							width="40"
							height="34"
							viewBox="0 0 40 34"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M6 0H34C37.3137 0 40 1.8804 40 4.2V23.8C40 26.1196 37.3137 28 34 28H17.6685C14.2795 30.3237 5.82336 35.4939 7.13715 33.5853C8.15239 32.1105 9.25009 29.5883 9.85122 28H6C2.68629 28 0 26.1196 0 23.8V4.2C0 1.8804 2.68629 0 6 0Z"
								fill="#347362"
							/>
						</svg>
					</div>
				</div>
				<div class="row">
					<div class="col-md-12 testialllist">
						<carousel :autoplay="false" :nav="false" :dots="false" :items="1">
							<template slot="prev"
								><span class="prev"
									><svg
										width="41"
										height="12"
										viewBox="0 0 41 12"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											opacity="0.2"
											d="M0.469669 5.46967C0.176777 5.76256 0.176777 6.23744 0.469669 6.53033L5.24264 11.3033C5.53553 11.5962 6.01041 11.5962 6.3033 11.3033C6.5962 11.0104 6.5962 10.5355 6.3033 10.2426L2.06066 6L6.3033 1.75736C6.5962 1.46447 6.5962 0.989593 6.3033 0.696699C6.01041 0.403806 5.53553 0.403806 5.24264 0.696699L0.469669 5.46967ZM41 5.25L1 5.25V6.75L41 6.75V5.25Z"
											fill="#0F393B"
										/></svg></span
							></template>
							<div class="textilist">
								<p>
									"I have never seen a more effective SEO company. SEO Suite
									helped me rank my websites on the first page for my target
									keywords, which led to a huge increase in advertising
									revenue."
								</p>
								<h4>Emily R.</h4>
								<h5>SEO Specialist</h5>
							</div>
							<div class="textilist">
								<p>
									"SEO Suite is the perfect business solution for my company.
									I'm a young entrepreneur and enjoy working on creative
									projects, but I still want to grow my company. A friend
									recommended SEO Suite to me and it has been such an easy way
									for me to get started."
								</p>
								<h4>Reece H.</h4>
								<h5>Enrepeneur</h5>
							</div>
							<div class="textilist">
								<p>
									"I am a marketing specialist in the US and I decided to use
									Seo Suite. I like how it is so easy to learn and use. It also
									is very user-friendly and offers many different services,
									which was perfect for me."
								</p>
								<h4>Ethan J.</h4>
								<h5>Marketing Specialist</h5>
							</div>
							<template slot="next"
								><span class="next"
									><svg
										width="41"
										height="12"
										viewBox="0 0 41 12"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											opacity="0.2"
											d="M40.5303 6.53033C40.8232 6.23744 40.8232 5.76257 40.5303 5.46967L35.7574 0.696702C35.4645 0.403809 34.9896 0.403809 34.6967 0.696702C34.4038 0.989596 34.4038 1.46447 34.6967 1.75736L38.9393 6L34.6967 10.2426C34.4038 10.5355 34.4038 11.0104 34.6967 11.3033C34.9896 11.5962 35.4645 11.5962 35.7574 11.3033L40.5303 6.53033ZM-6.55671e-08 6.75L40 6.75L40 5.25L6.55671e-08 5.25L-6.55671e-08 6.75Z"
											fill="#0F393B"
										/></svg></span
							></template>
						</carousel>
					</div>
				</div>
			</div>
		</section>
		<!--end-->

		<!--content -->
		<section class="call_home_Sc">
			<div class="container">
				<div class="row">
					<div class="col-md-12">
						<div class="extrahome-content text-center">
							<h4>100% hosted on the cloud</h4>
							<h5>You never need to download or install anything.</h5>
							<p>
								SEO Suite is hosted on a reliable cloud server that you can
								access from any device or browser of your choice.
							</p>
						</div>
					</div>
				</div>
			</div>
		</section>
		<!--end-->

		<!--full automated -->
		<section class="sc-automated">
			<div class="container">
				<!--start-row-->
				<div class="row">
					<div class="col-md-4">
						<div class="scaccording">
							<h3>Web Performance automated</h3>
							<p>Let us do the ‘boring’ stuff, while do things you do best.</p>

							<div class="accordion faqsc" role="tablist">
								<!--dropdown-1-->
								<b-card no-body>
									<b-card-header header-tag="header" role="tab" @click="click1">
										<b-button
											class="colorsc1"
											block
											v-b-toggle.accordion1
											variant="info"
											>Deep Know-how</b-button
										>
									</b-card-header>
									<b-collapse
										id="accordion1"
										visible
										accordion="my-accordion"
										role="tabpanel"
									>
										<b-card-body>
											<b-card-text
												>Know exactly how your website performs. View all the
												required statistical data neetly placed in front of you
												on a nice-looking dashboard.</b-card-text
											>
											<router-link :to="`/${$i18n.locale}/contacts`" class="cl1"
												>Get started
												<svg
													width="11"
													height="9"
													viewBox="0 0 11 9"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														d="M0 4.5H10M10 4.5L6.5 1M10 4.5L6.5 8"
														stroke="#EDCB50"
														stroke-width="1.5"
														stroke-linejoin="round"
													/></svg
											></router-link>
											<div class="homeauto_img mobileshow">
												<img
													src="@/assets/images/a-1.png"
													alt=""
													v-if="scdropdown0"
												/>
											</div>
										</b-card-body>
									</b-collapse>
								</b-card>
								<!--END-->
								<!--dropdown-2-->
								<b-card no-body>
									<b-card-header header-tag="header" role="tab" @click="click2">
										<b-button
											class="colorsc2"
											block
											v-b-toggle.accordion2
											variant="info"
											>Brand Awareness</b-button
										>
									</b-card-header>
									<b-collapse
										id="accordion2"
										accordion="my-accordion"
										role="tabpanel"
									>
										<b-card-body>
											<b-card-text
												>Check your website’s content for originality, spelling
												mistakes, bad translation etc. and fix all the issues
												right away!</b-card-text
											>
											<router-link :to="`/${$i18n.locale}/contacts`" class="cl2"
												>Get started
												<svg
													width="11"
													height="9"
													viewBox="0 0 11 9"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														d="M0 4.5H10M10 4.5L6.5 1M10 4.5L6.5 8"
														stroke="#EF8451"
														stroke-width="1.5"
														stroke-linejoin="round"
													/></svg
											></router-link>
											<div class="homeauto_img mobileshow">
												<img
													src="@/assets/images/a-2.png"
													alt=""
													v-if="scdropdown1"
												/>
											</div>
										</b-card-body>
									</b-collapse>
								</b-card>
								<!--END-->
								<!--dropdown-3-->
								<b-card no-body>
									<b-card-header header-tag="header" role="tab" @click="click3">
										<b-button
											class="colorsc3"
											block
											v-b-toggle.accordion3
											variant="info"
											>Marketing Automations</b-button
										>
									</b-card-header>
									<b-collapse
										id="accordion3"
										accordion="my-accordion"
										role="tabpanel"
									>
										<b-card-body>
											<b-card-text
												>Create unique emails and set up an automatic email
												campaigns to contact your clients with a simple
												drag’n’drop workflow builder.</b-card-text
											>
											<router-link :to="`/${$i18n.locale}/contacts`" class="cl3"
												>Get started
												<svg
													width="10"
													height="8"
													viewBox="0 0 10 8"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														fill-rule="evenodd"
														clip-rule="evenodd"
														d="M5.24408 0.234315C5.56951 -0.0781049 6.09715 -0.0781049 6.42259 0.234315L9.75592 3.43431C10.0814 3.74673 10.0814 4.25327 9.75592 4.56569L6.42259 7.76569C6.09715 8.0781 5.56951 8.0781 5.24408 7.76569C4.91864 7.45327 4.91864 6.94673 5.24408 6.63432L7.15482 4.8H0.833333C0.373096 4.8 0 4.44183 0 4C0 3.55817 0.373096 3.2 0.833333 3.2H7.15482L5.24408 1.36569C4.91864 1.05327 4.91864 0.546734 5.24408 0.234315Z"
														fill="#347362"
													/></svg
											></router-link>
											<div class="homeauto_img mobileshow">
												<img
													src="@/assets/images/a-3.png"
													alt=""
													v-if="scdropdown2"
												/>
											</div>
										</b-card-body>
									</b-collapse>
								</b-card>
								<!--END-->
								<!--dropdown-4-->
								<b-card no-body>
									<b-card-header header-tag="header" role="tab" @click="click4">
										<b-button
											class="colorsc4"
											block
											v-b-toggle.accordion4
											variant="info"
											>Professional Analysis</b-button
										>
									</b-card-header>
									<b-collapse
										id="accordion4"
										accordion="my-accordion"
										role="tabpanel"
									>
										<b-card-body>
											<b-card-text
												>Monitor both your backlinks as well as those of your
												competitors and in 3 simple steps create campaigns to
												contact them directly.</b-card-text
											>
											<router-link :to="`/${$i18n.locale}/contacts`" class="cl4"
												>Get started
												<svg
													width="10"
													height="8"
													viewBox="0 0 10 8"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														fill-rule="evenodd"
														clip-rule="evenodd"
														d="M5.24408 0.234315C5.56951 -0.0781049 6.09715 -0.0781049 6.42259 0.234315L9.75592 3.43431C10.0814 3.74673 10.0814 4.25327 9.75592 4.56569L6.42259 7.76569C6.09715 8.07811 5.56951 8.07811 5.24408 7.76569C4.91864 7.45327 4.91864 6.94673 5.24408 6.63432L7.15482 4.8H0.833333C0.373096 4.8 0 4.44183 0 4C0 3.55817 0.373096 3.2 0.833333 3.2H7.15482L5.24408 1.36569C4.91864 1.05327 4.91864 0.546734 5.24408 0.234315Z"
														fill="#EF8451"
													/></svg
											></router-link>
											<div class="homeauto_img mobileshow">
												<img
													src="@/assets/images/a-4.png"
													alt=""
													v-if="scdropdown3"
												/>
											</div>
										</b-card-body>
									</b-collapse>
								</b-card>
								<!--END-->
								<!--dropdown-5-->
								<b-card no-body>
									<b-card-header header-tag="header" role="tab" @click="click5">
										<b-button
											class="colorsc5"
											block
											v-b-toggle.accordion5
											variant="info"
											>Deep Competitors’ Analysis</b-button
										>
									</b-card-header>
									<b-collapse
										id="accordion5"
										accordion="my-accordion"
										role="tabpanel"
									>
										<b-card-body>
											<b-card-text
												>Let us search for issues that may reduce your website’s
												performance and hold you from being the top of the
												game.</b-card-text
											>
											<router-link :to="`/${$i18n.locale}/contacts`" class="cl5"
												>Get started
												<svg
													width="11"
													height="9"
													viewBox="0 0 11 9"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														d="M0 4.5H10M10 4.5L6.5 1M10 4.5L6.5 8"
														stroke="#EDCB50"
														stroke-width="1.5"
														stroke-linejoin="round"
													/></svg
											></router-link>
											<div class="homeauto_img mobileshow">
												<img
													src="@/assets/images/a-5.png"
													alt=""
													v-if="scdropdown4"
												/>
											</div>
										</b-card-body>
									</b-collapse>
								</b-card>
								<!--END-->
							</div>
						</div>
					</div>
					<div class="col-md-8 laptopshow">
						<div class="homeauto_img">
							<img src="@/assets/images/a-1.png" alt="" v-if="scdropdown0" />
							<img src="@/assets/images/a-2.png" alt="" v-if="scdropdown1" />
							<img src="@/assets/images/a-3.png" alt="" v-if="scdropdown2" />
							<img src="@/assets/images/a-4.png" alt="" v-if="scdropdown3" />
							<img src="@/assets/images/a-5.png" alt="" v-if="scdropdown4" />
						</div>
					</div>
				</div>

				<!--end row-->
			</div>
		</section>
		<!--end-->

		<section class="contactForm">
			<div class="container">
				<div class="row">
					<div class="col-md-6">
						<div class="flay"><img src="@/assets/images/fly.svg" alt="" /></div>
					</div>
					<div class="col-md-6">
						<div class="scform">
							<h3>Know first about future updates!</h3>
							<form action="#">
								<label for="">Name</label>
								<input type="text" placeholder="John Doe" />

								<label for="">Email</label>
								<input type="email" placeholder="johndoe@seosuite.com" />

								<div class="link_submitsc">
									<router-link :to="`/${$i18n.locale}/signup`"
										>Sign me up</router-link
									>
									<span>or</span>
									<input type="submit" value="Leave us a message" />
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		</section>

		<!--Three spots-->
		<section class="threespots">
			<div class="container">
				<div class="row">
					<div class="col-md-12">
						<h3>It is very easy to start!</h3>
					</div>
				</div>
				<div class="row">
					<div class="col-md-4">
						<div class="spotsbox">
							<svg
								width="53"
								height="40"
								viewBox="0 0 53 40"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M52.9991 6.62149V32.315C52.9991 35.2789 52.0766 37.1714 50.7271 38.2795C49.4351 39.3404 48.0144 39.4612 47.4218 39.4612C47.3035 39.4612 46.7221 39.4534 45.7808 39.4408C39.3298 39.3545 15.9785 39.0422 9.01762 39.4585C5.63869 39.6606 3.33768 39.097 1.87952 38.0208C0.425158 36.9474 -0.0456728 35.4605 0.113053 34.2454V6.75076C-0.0878536 5.6548 -0.021721 4.65665 0.317329 3.77928C0.67424 2.85569 1.28932 2.181 1.97804 1.71045C3.29546 0.810355 4.92708 0.615968 5.9919 0.66338C11.3185 0.863181 19.6469 1.10285 27.3222 1.17274C31.1619 1.2077 34.8283 1.20007 37.8693 1.12433C40.9447 1.04774 43.2827 0.902919 44.524 0.684759C47.6049 0.143282 49.833 0.829225 51.2653 2.25547C52.6228 3.60719 53.0212 5.38707 52.9991 6.62149ZM49.1485 4.38128C48.5802 3.81536 47.4306 3.2199 45.0433 3.63947C43.5504 3.90184 40.9987 4.04733 37.944 4.1234C34.855 4.20034 31.1509 4.20772 27.2949 4.17261C19.5813 4.10237 11.2202 3.86166 5.87384 3.66106L5.86185 3.66061C5.16775 3.62901 4.26104 3.78399 3.67042 4.18751C3.4038 4.36968 3.22143 4.58695 3.11565 4.86066C3.00815 5.13885 2.93591 5.58983 3.08256 6.30607C3.10284 6.40508 3.11305 6.50589 3.11305 6.60696V34.3572C3.11305 34.4445 3.10544 34.5315 3.09031 34.6175C3.06899 34.7384 3.0646 35.1668 3.66101 35.607C4.31341 36.0885 5.78983 36.6462 8.83852 36.4638C15.9943 36.0359 40.0771 36.3627 46.0748 36.444C46.8598 36.4547 47.335 36.4612 47.4218 36.4612C47.6687 36.4612 48.2866 36.4017 48.8233 35.961C49.3026 35.5674 49.9991 34.6369 49.9991 32.315V6.60696C49.9991 6.6008 49.9991 6.59463 49.9992 6.58847C49.9992 6.58402 49.9993 6.57956 49.9994 6.57511C50.0131 5.92811 49.7853 5.0154 49.1485 4.38128ZM16.4554 10.7441C15.6769 10.8941 14.7801 11.3172 13.8043 12.254C12.856 13.1643 12.4651 14.0188 12.3508 14.7721C12.2339 15.5417 12.3842 16.3522 12.7642 17.1893C13.4474 18.6942 14.7824 20.0782 15.9838 21.0024C16.1747 20.9689 16.3669 20.9411 16.5602 20.9195C19.8718 20.211 21.3704 18.8514 22.033 17.6548C22.7585 16.3448 22.6715 14.8958 22.3362 13.9124C21.5656 12.8351 20.257 11.5648 18.7639 10.9886C18.0092 10.6973 17.2372 10.5935 16.4554 10.7441ZM21.9345 21.9801C23.1665 21.1684 24.058 20.1907 24.6575 19.1082C25.9532 16.7684 25.6957 14.2698 25.0767 12.6722C25.0354 12.5656 24.982 12.4641 24.9177 12.3696C23.9525 10.953 22.1582 9.08288 19.8441 8.1898C18.6611 7.73326 17.3151 7.52327 15.8877 7.79833C14.4569 8.07404 13.0533 8.81622 11.7267 10.0899C10.3725 11.3899 9.61216 12.824 9.38476 14.3218C9.15984 15.8032 9.47724 17.2062 10.0326 18.4294C10.684 19.8644 11.6996 21.1368 12.7458 22.1572C9.71622 23.7952 7.34629 26.683 5.95835 29.0283C5.53643 29.7412 5.77235 30.6612 6.48528 31.0831C7.19821 31.505 8.11819 31.2691 8.54011 30.5562C10.1336 27.8637 12.8871 24.8924 15.9457 24.0802C16.3157 24.0233 16.6736 23.9591 17.0196 23.888C18.1629 23.7838 19.3685 23.9997 20.6337 24.6864C22.3126 25.5976 24.1846 27.3883 26.1127 30.5697C26.5421 31.2782 27.4645 31.5044 28.173 31.075C28.8814 30.6456 29.1077 29.7232 28.6783 29.0148C26.58 25.5527 24.3622 23.2967 22.0648 22.0497C22.0214 22.0262 21.9779 22.003 21.9345 21.9801ZM27.6943 11.1719C27.6943 10.3435 28.3659 9.67193 29.1943 9.67193H46.4625C47.291 9.67193 47.9625 10.3435 47.9625 11.1719C47.9625 12.0004 47.291 12.6719 46.4625 12.6719H29.1943C28.3659 12.6719 27.6943 12.0004 27.6943 11.1719ZM27.6943 19.2207C27.6943 18.3923 28.3659 17.7207 29.1943 17.7207H46.4625C47.291 17.7207 47.9625 18.3923 47.9625 19.2207C47.9625 20.0491 47.291 20.7207 46.4625 20.7207H29.1943C28.3659 20.7207 27.6943 20.0491 27.6943 19.2207ZM30.0927 27.1494C30.0927 26.3209 30.7642 25.6494 31.5927 25.6494H46.4625C47.291 25.6494 47.9625 26.3209 47.9625 27.1494C47.9625 27.9778 47.291 28.6494 46.4625 28.6494H31.5927C30.7642 28.6494 30.0927 27.9778 30.0927 27.1494Z"
									fill="#347362"
								/>
							</svg>
							<h4>Set up your account</h4>
							<p>
								With a few simple clicks create a trial account for 7 days, it’s
								very easy!
							</p>
						</div>
					</div>
					<div class="col-md-4">
						<div class="spotsbox">
							<svg
								width="42"
								height="43"
								viewBox="0 0 42 43"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M18.902 0.514572C19.4745 0.434303 20.0421 0.690093 20.3611 1.1721C20.9241 2.02264 22.1611 3.11802 23.9577 3.4362C25.7016 3.74504 28.2247 3.3637 31.4729 0.819204C31.9459 0.448636 32.5945 0.396154 33.121 0.685838C33.6475 0.975521 33.9503 1.55145 33.8904 2.14939C33.7741 3.31181 33.9698 5.21828 34.9598 6.96269C35.9158 8.64733 37.6507 10.2567 40.8006 10.9009C41.2875 11.0005 41.6934 11.3347 41.8846 11.7934C42.0758 12.2522 42.0274 12.7758 41.7553 13.1916C41.0559 14.2609 40.1866 16.1706 39.9361 18.286C39.6892 20.3717 40.0495 22.5477 41.6369 24.392C42.0214 24.8386 42.1087 25.469 41.86 26.0033C41.6114 26.5376 41.0729 26.8769 40.4837 26.8704C39.4064 26.8586 37.7334 27.2121 36.364 28.2901C35.0622 29.3149 33.8979 31.0982 33.8979 34.2637C33.8979 35.0921 33.2263 35.7637 32.3979 35.7637C31.5695 35.7637 30.8979 35.0921 30.8979 34.2637C30.8979 30.2437 32.4343 27.5656 34.5084 25.9328C35.604 25.0704 36.8103 24.5296 37.9442 24.2193C36.9058 22.1293 36.7221 19.9168 36.9569 17.9334C37.1618 16.2027 37.6875 14.6009 38.2817 13.3101C35.3784 12.278 33.4915 10.4536 32.3506 8.44341C31.6503 7.20932 31.2413 5.92527 31.0344 4.7402C28.1972 6.38241 25.63 6.77903 23.4346 6.39024C21.969 6.13068 20.7393 5.53263 19.7684 4.81178C19.0356 6.91184 18.2638 8.56781 16.9849 9.80766C15.2263 11.5127 12.7097 12.2613 8.90641 12.9713C8.09205 13.1234 7.30864 12.5864 7.1566 11.7721C7.00457 10.9577 7.54148 10.1743 8.35584 10.0223C12.194 9.3057 13.8565 8.66228 14.8967 7.65375C15.9709 6.61234 16.5872 5.00628 17.6801 1.54805C17.8542 0.996887 18.3296 0.594842 18.902 0.514572ZM25.1229 13.0936C23.2804 13.2554 21.3122 14.3445 20.057 15.3658C19.4145 15.8887 18.4697 15.7916 17.9468 15.149C17.424 14.5064 17.521 13.5617 18.1636 13.0388C19.6681 11.8147 22.1929 10.3393 24.8606 10.1051C26.2282 9.98505 27.6831 10.1888 29.0303 10.976C30.3804 11.7649 31.49 13.0623 32.2978 14.8983C33.8593 18.4478 33.7311 21.4182 32.7724 23.7074C31.8369 25.9413 30.1663 27.393 28.8326 28.0679C28.0935 28.442 27.191 28.1461 26.8169 27.4069C26.4429 26.6678 26.7388 25.7653 27.478 25.3912C28.246 25.0025 29.3743 24.0552 30.0052 22.5486C30.613 21.0974 30.8186 18.9859 29.5518 16.1063C28.9453 14.7278 28.216 13.9748 27.5169 13.5663C26.8149 13.1561 26.0104 13.0157 25.1229 13.0936ZM10.3079 16.9948C13.8375 16.3172 17.3612 17.3268 19.2779 18.9318C22.1421 21.3303 23.1465 24.1134 22.9892 26.8862C22.8653 29.0711 22.0266 31.1497 21.0451 32.9347C23.8621 35.29 28.3654 39.0864 29.2174 39.9409C29.8024 40.5275 29.8011 41.4772 29.2145 42.0622C28.6279 42.6472 27.6781 42.6458 27.0931 42.0592C26.3782 41.3423 22.2705 37.8726 19.4248 35.4907C19.002 36.0724 18.5507 36.6435 18.0809 37.2054C16.7498 38.7973 14.624 39.6133 12.4898 39.8515C10.3249 40.0932 7.92769 39.7717 5.81456 38.8473C3.69518 37.9202 1.77559 36.344 0.754112 34.0272C-0.27561 31.6917 -0.296557 28.8222 0.975504 25.512C3.01711 20.1992 6.64623 17.6978 10.3079 16.9948ZM10.8735 19.941C8.26399 20.442 5.4583 22.21 3.77585 26.5881C2.72038 29.3347 2.85779 31.3623 3.49914 32.8169C4.14874 34.2903 5.41293 35.3972 7.01686 36.0988C8.62705 36.8031 10.4926 37.0559 12.157 36.8701C13.8519 36.6808 15.1217 36.0676 15.7794 35.281C16.5684 34.3374 17.2629 33.4112 17.8338 32.486C18.9854 30.6195 19.8854 28.6302 19.994 26.7163C20.0964 24.9128 19.5078 23.0373 17.3518 21.2319C16.199 20.2665 13.615 19.4147 10.8735 19.941ZM10.6176 23.2365C10.8824 22.4515 11.7333 22.0298 12.5183 22.2946C13.1653 22.5129 14.1302 22.9388 15.0169 23.5449C15.8538 24.1169 16.8986 25.0362 17.256 26.3303C17.4765 27.1288 17.0079 27.955 16.2094 28.1755C15.4108 28.396 14.5847 27.9274 14.3642 27.1289C14.2973 26.8866 13.9967 26.4813 13.3241 26.0217C12.7014 25.5961 11.9928 25.2834 11.5595 25.1373C10.7745 24.8725 10.3528 24.0215 10.6176 23.2365Z"
									fill="#347362"
								/>
							</svg>
							<h4>Choose a plan</h4>
							<p>Use the tools and choose a plan later.</p>
						</div>
					</div>
					<div class="col-md-4">
						<div class="spotsbox">
							<svg
								width="43"
								height="43"
								viewBox="0 0 43 43"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M20.392 0.801242C21.0541 0.303336 21.9945 0.436445 22.4924 1.09855C24.5012 3.76987 27.5975 10.8389 23.4463 17.6261C23.014 18.3328 22.0907 18.5553 21.384 18.123C20.6772 17.6908 20.4548 16.7675 20.887 16.0607C24.1197 10.7753 21.7446 5.09562 20.0947 2.90162C19.5968 2.23952 19.7299 1.29915 20.392 0.801242ZM30.8252 4.57919C32.1004 3.56041 33.7991 3.39838 34.8679 3.47233C34.9427 3.47751 35.0171 3.48829 35.0903 3.5046C37.8739 4.12431 39.5065 5.51449 39.9853 7.40532C40.4205 9.12429 39.7616 10.7737 39.1379 11.7272C39.0456 11.8682 38.9303 11.9927 38.7966 12.0954C37.8396 12.831 36.2032 13.7366 34.459 13.7877C33.5461 13.8145 32.5647 13.6056 31.6818 12.9734C30.8039 12.3448 30.1536 11.3911 29.7289 10.1575C29.3202 8.97057 29.1984 7.87847 29.4034 6.89862C29.614 5.89168 30.1457 5.12203 30.8252 4.57919ZM32.3398 7.51275C32.2768 7.81391 32.2756 8.33912 32.5654 9.18079C32.8392 9.9758 33.1722 10.3508 33.4283 10.5342C33.6794 10.714 33.9827 10.8004 34.3711 10.789C35.1462 10.7663 36.0633 10.3529 36.7538 9.87355C37.0499 9.33163 37.2101 8.66719 37.0771 8.14172C36.9716 7.72528 36.5598 6.93182 34.5538 6.45934C33.8629 6.43163 33.1119 6.59218 32.6977 6.92305C32.5218 7.06362 32.3971 7.23869 32.3398 7.51275ZM8.78988 4.00955C9.31963 3.37264 10.2654 3.28577 10.9023 3.81552C11.6931 4.47324 12.7432 5.65108 13.4823 7.1601C14.2283 8.68313 14.7047 10.6484 14.1364 12.7773C13.9228 13.5777 13.1007 14.0533 12.3003 13.8397C11.4999 13.626 11.0243 12.804 11.2379 12.0036C11.5677 10.7679 11.3165 9.55839 10.7881 8.47972C10.2529 7.38703 9.48202 6.53628 8.98392 6.12198C8.347 5.59223 8.26013 4.64647 8.78988 4.00955ZM2.54135 8.32527C3.56783 7.81629 6.16108 7.18671 8.3015 9.02634C10.45 10.8729 10.017 13.2188 9.40902 14.3117C9.04615 15.0841 8.27358 15.8434 7.12626 16.2052C5.91438 16.5873 4.40921 16.4937 2.63172 15.7545C1.67487 15.3566 0.891595 14.7902 0.426395 13.9942C-0.0570289 13.1669 -0.0784185 12.296 0.110812 11.5532C0.456691 10.1954 1.53566 9.08566 2.27084 8.4977C2.35459 8.43072 2.44528 8.37291 2.54135 8.32527ZM4.00486 10.9573C3.80218 11.1338 3.59196 11.3483 3.4131 11.5783C3.18563 11.8708 3.06232 12.1196 3.01797 12.2937C2.98382 12.4278 3.0056 12.4628 3.01494 12.4779C3.01553 12.4788 3.01608 12.4797 3.01655 12.4805C3.04274 12.5253 3.1939 12.7392 3.78369 12.9845C5.09951 13.5317 5.86025 13.4588 6.22413 13.344C6.55912 13.2384 6.67403 13.0663 6.69005 13.0423C6.6922 13.0391 6.69257 13.0385 6.69146 13.0411C6.71934 12.9755 6.75186 12.9119 6.78878 12.8509C6.82993 12.7829 6.92522 12.546 6.90373 12.2576C6.88638 12.0248 6.79057 11.6835 6.34607 11.3015C5.91475 10.9308 5.43436 10.8006 4.96651 10.7948C4.56783 10.7899 4.21777 10.8777 4.00486 10.9573ZM11.3161 15.3692C11.588 14.7563 12.2337 14.3983 12.8976 14.4924C16.6499 15.024 24.4555 18.8534 28.437 29.5557C28.7081 30.2847 28.3771 31.1 27.6746 31.4337C24.6654 32.8627 15.8143 36.677 4.19198 40.6514C3.64904 40.8371 3.04775 40.6967 2.6431 40.2899C2.23845 39.883 2.10136 39.281 2.28997 38.7391C3.91426 34.0719 7.99698 22.85 11.3161 15.3692ZM13.5656 17.7107C10.9709 23.7075 7.99942 31.672 6.16244 36.7901C14.913 33.6968 21.7407 30.8325 25.1104 29.3128C21.854 21.7026 16.5292 18.5983 13.5656 17.7107ZM40.767 23.1C35.1173 19.9372 29.1948 21.2713 27.0462 22.2825C26.2966 22.6353 25.403 22.3136 25.0502 21.5641C24.6975 20.8145 25.0191 19.9209 25.7687 19.5681C28.5261 18.2704 35.509 16.7183 42.2325 20.4823C42.9553 20.887 43.2133 21.8011 42.8086 22.5239C42.4039 23.2468 41.4899 23.5047 40.767 23.1ZM37.8659 33.6575C35.6747 31.6454 32.6814 31.7302 31.5178 32.027C30.7151 32.2317 29.8984 31.7469 29.6937 30.9441C29.489 30.1414 29.9738 29.3247 30.7765 29.12C32.5233 28.6746 36.6978 28.512 39.8949 31.4477C40.5051 32.008 40.5456 32.9569 39.9853 33.5671C39.425 34.1773 38.4761 34.2178 37.8659 33.6575ZM33.6459 33.6058C35.0701 34.1854 36.8058 35.4223 37.0064 37.6108C37.1634 39.3235 36.3376 40.5498 35.3644 41.299C34.4484 42.004 33.3604 42.3374 32.6163 42.4473C31.1472 42.6696 27.8423 42.2595 26.6127 38.7369C26.0318 37.0727 26.2365 35.6331 27.0898 34.584C27.8021 33.7083 28.7966 33.3203 29.5393 33.1929C30.1345 33.0056 30.8183 32.9968 31.4108 33.0535C32.1157 33.1209 32.8978 33.3013 33.6459 33.6058ZM30.4597 36.0485C30.4543 36.0495 30.4525 36.0499 30.4542 36.0492C30.3354 36.0964 30.2112 36.1283 30.0844 36.144C29.8415 36.1741 29.5573 36.3046 29.4171 36.477C29.3627 36.544 29.3106 36.6377 29.2907 36.7983C29.2695 36.9699 29.2793 37.2732 29.4451 37.7482C30.0104 39.3677 31.4731 39.587 32.1682 39.481L32.1764 39.4797C32.5548 39.4242 33.1235 39.238 33.5344 38.9217C33.8895 38.6484 34.0615 38.3491 34.019 37.8847C33.9701 37.352 33.5231 36.7947 32.515 36.3844C32.0471 36.194 31.5507 36.0805 31.1252 36.0398C30.7112 36.0002 30.4973 36.0413 30.4597 36.0485Z"
									fill="#347362"
								/>
							</svg>
							<h4>Enjoy automation</h4>
							<p>
								You are set to go. Now sit back, relax and watch SEO Suite do
								everything for you.
							</p>
						</div>
					</div>
				</div>
			</div>
		</section>
		<!--end-->

		<!--call a action-->
		<CallAction />
		<!--END-->
	</div>
</template>

<script>
	// @ is an alias to /src
	import MainPage from "@/layouts/MainPage.vue";
	import CallAction from "@/components/Call_Action.vue";
	import "@fancyapps/ui/dist/fancybox.css";
	import "@fancyapps/ui/src/Fancybox/Fancybox.js";
	import carousel from "vue-owl-carousel";
	export default {
		name: "Home",
		components: {
			CallAction,
			carousel,
		},

		//this for layout call
		created() {
			this.$parent.$emit("update:layout", MainPage);
		},
		//this for layout render
		render() {
			return this.$slots.default[0];
		},

		data: () => ({
			//this for image load dropdown tabs
			scdropdown0: true,
			scdropdown1: false,
			scdropdown2: false,
			scdropdown3: false,
			scdropdown4: false,
		}),
		methods: {
			click1() {
				this.scdropdown0 = true;
				this.scdropdown1 = false;
				this.scdropdown2 = false;
				this.scdropdown3 = false;
				this.scdropdown4 = false;
			},
			click2() {
				this.scdropdown1 = true;
				this.scdropdown0 = false;
				this.scdropdown2 = false;
				this.scdropdown3 = false;
				this.scdropdown4 = false;
			},
			click3() {
				this.scdropdown2 = true;
				this.scdropdown1 = false;
				this.scdropdown0 = false;
				this.scdropdown3 = false;
				this.scdropdown4 = false;
			},
			click4() {
				this.scdropdown3 = true;
				this.scdropdown1 = false;
				this.scdropdown2 = false;
				this.scdropdown0 = false;
				this.scdropdown4 = false;
			},
			click5() {
				this.scdropdown4 = true;
				this.scdropdown1 = false;
				this.scdropdown2 = false;
				this.scdropdown3 = false;
				this.scdropdown0 = false;
			},
		},

		//Meta info title + description + others meta
		metaInfo() {
			return {
				title: "SEO Suite",
				htmlAttrs: {
					lang: this.$i18n.locale,
				},
				meta: [
					{ name: "description", content: "SEO Suite" },
					{ property: "og:title", content: "SEO Suite" },
					{ property: "og:site_name", content: "SEO Suite" },
					{ property: "og:type", content: "website" },
					{ name: "robots", content: "index,follow" },
				],
			};
		},
		//end meta info
	};
</script>
